<template>
    <div class="modal modal-attach fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="mb-4">
                            <h4>
                                Add Attachment/PDF
                            </h4>
                        </div>
                        <ValidationObserver ref="form" class="row">
                            <ValidationProvider
                                class="col-12"
                                name="Employee"
                                rules="required"
                                v-slot="{errors}"
                            >
                                <div class="form-group form-group-2 mb-3">
                                    <label for="" class="form-label">Select the Applicant</label>
                                    <select class="form-control" v-model="applicant_id">
                                        <option v-for="applicant in applicants"
                                                :value="applicant.id">
                                            {{ applicant.name ?? '' }} {{ applicant.last_name ?? '' }}
                                        </option>
                                    </select>
                                    <FormError :error="errors[0]" name="Employee"></FormError>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider
                                class="col-md-6"
                                name="Regular"
                                rules="numeric"
                                v-slot="{errors}"
                            >
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Regular </label>
                                    <input type="number" min=0 class="form-control" v-model="regular">
                                    <FormError :error="errors[0]" name="Regular"></FormError>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider
                                class="col-md-6"
                                name="Overtime"
                                rules="numeric"
                                v-slot="{errors}"
                            >
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Overtime</label>
                                    <input type="number" min="0" class="form-control" v-model="overtime">
                                    <FormError :error="errors[0]" name="Overtime"></FormError>
                                </div>
                            </ValidationProvider>

                            <div class="col-lg-12" v-if="fileInfo.file_path">
                                <div class="uploaded-file">
                                    <div class="d-flex align-items-center">
                                        <img src="/img/svg/file-b.svg" alt="">
                                        <p style="margin: 0; padding-left: 10px;">{{ fileInfo.original_filename }}</p>
                                    </div>
                                    <button
                                        class="img-btn delete-link"
                                        @click="showDeleteModal(fileInfo.id, 'attachment')"
                                    ><img src="/img/svg/on.svg" alt=""></button>
                                    <ActionModal confirm-text="Yes"
                                                 reject-text="No"
                                                 :modalId="getDeleteModalId(fileInfo.id, 'attachment')"
                                                 @confirm="deleteAttachment(fileInfo.id)">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to delete this item?
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>
                                </div>
                            </div>
                            <div class="col-lg-12" v-else>
                                <a href="javascript:void(0)"
                                   class="btn btn--middle w-100 mb-4"
                                   @click="$refs.fileInput.click()"
                                >+Add File</a>
                                <input
                                    type="file"
                                    style="display: none"
                                    @change="selectFile"
                                    ref="fileInput"
                                >
                            </div>
                            <div class="col-lg-12">
                                <p><b>Note:</b> Attaching a file to an applicant will override the need for the
                                    submission of a timesheet. The hours will not be calculated for the applicant. Once
                                    uploaded this action can not be undone.</p>
                            </div>
                        </ValidationObserver>
                        <div class="btns-wrap">
                            <button data-dismiss="modal" class="btn btn--outline-primary" @click="closeModal">cancel</button>
                            <button class="btn btn--secondary" @click="validateForm">proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import TimeSheetService from "./services/TimeSheetService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'TimesheetAttachmentsModal',
    components: {ActionModal},
    mixins: [ModalHandler, DateConverter],
    props: {
        id: String,
        periodId: String,
        applicants: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            fileInfo: {},
            regular: null,
            overtime: null,
            applicant_id: null,
        }
    },
    emits: ['confirm'],
    methods: {
         addApplicantFile() {

            const payload = {
                original_filename: this.fileInfo.original_filename,
                regular: this.getMilliseconds(this.regular)  ,
                applicant_id: this.applicant_id,
                overtime: this.getMilliseconds(this.overtime),
                file_id: this.fileInfo.id,
                file_path: this.fileInfo.file_path
            }
            this.$emit('confirm', payload);
            $('#file-1').modal('hide');
            this.fileInfo = {}
            this. regular = null
            this.overtime = null
            this.applicant_id =  null
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
            } else if (!this.fileInfo.id){
                this.$showErrorMessage('Please select file')
            } else {
                this.addApplicantFile()
            }
        },
        async closeModal() {
             try {
                 await this.deleteAttachment
                 this.fileInfo = {}
                 this. regular = null
                 this.overtime = null
                 this.applicant_id =  null
                 $('#file-1').modal('hide');
             } catch (e) {
                 console.error(e)
             }
        },
        async deleteAttachment(id) {
            try {
                await TimeSheetService.deleteTimesheetFile(this.periodId, id);
                this.fileInfo = {}
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        async selectFile(event) {
            const uploadedFiles = this.$refs.fileInput.files;
            if (!uploadedFiles || uploadedFiles.length === 0) {
                console.error("No file selected");
                return;
            }

            const uploadedFile = uploadedFiles[0];
            try {
                const content = await this.readFileAsync(uploadedFile);
                const file = {
                    file: uploadedFile,
                    name: uploadedFile.name,
                    content,
                }
                await this.sendFileForGettingInfo(file)
            } catch (error) {
                console.error("Error reading file:", error);
            }
        },
        async sendFileForGettingInfo(file) {
            const formData = new FormData();
            formData.append('file', file.file);
            try {
                const {data: response} = await TimeSheetService.getFileInfo(this.periodId, formData);
                this.fileInfo = response
            } catch (error) {
                this.$showErrorMessage('File was not uploaded');
            }
        }
    },
}

</script>

<style scoped>

</style>
